<template>
  <div class="graphics container">
    <div class="head-data">
      <h6 class="title">{{ title }} {{ selectedYear }}</h6>
    </div>
    <canvas class="canvas" :id="idGraphic"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";
import {maxData} from "../../../components/tools/utils"
Chart.register(...registerables);

export default {
  name: "PlanetChart",
  data() {
    return {
      img: "",
      myChart: null,
      maxValue: 0
    };
  },
  props: ["titles", "content", "idGraphic", "title", "selectedYear"],
  watch: {
    content: function() {
      this.grafica();
    },
  },
  methods: {
    higherValue: function() {
      const data = this.content[1].concat(this.content[2]);
      data.sort((a,b) => b-a);

      return maxData(data[0]) ?? 0;
    },
    grafica: function() {
      var ctx = document.getElementById(this.idGraphic).getContext("2d");
      if (this.myChart != null) {
        this.myChart.destroy();
      }
      this.myChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.content[0],
          datasets: [
            {
              label: this.titles[0],
              data: this.content[1],
              backgroundColor: ["#770baa"],
              borderColor: ["#770baa"],
              barThickness: 40,
            },
            {
              label: this.titles[1],
              data: this.content[2] ?? "Datos no Encontrados",
              backgroundColor: ["#2ecc71"],
              borderColor: ["#2ecc71"],
              barThickness: 40,
            },
          ],
        },
        options: {
          scales: {
            y: {
              // max: this.higherValue(),
              beginAtZero: true,
              title: {
                display: true,
                text: "Personas",
                font: {
                  weight: "bold",
                },
              },
            },
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Resultados",
                font: {
                  weight: "bold",
                },
              },
            },
          },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
            },
          },
        },
      });
    },
  },
  mounted() {
    this.grafica();
  },
};
</script>

<style scoped>
.canvas {
  font-size: 14px;
  color: #052333;
  padding: 1rem 3rem;
}
.graphics {
  padding-bottom: 2rem;
  padding: 0 5rem;
}
.head-data {
  background-color: #cfcccc;
}
.title {
  padding: 1rem;
}
</style>
